module.exports = __webpack_public_path__ + "img/1-9-7.c7479012.png";